import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
    if (consent === "accepted") {
      enableAnalytics();
    }
  }, []);

  const enableAnalytics = () => {
    window.gtag?.("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  };

  const accept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    enableAnalytics();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie-consent", "declined");
    window.gtag?.("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
    setVisible(false);
  };

  return (
    <>
      {visible && (
        <div className="fixed bottom-0 left-0 right-0 z-[100] animate-in slide-in-from-bottom-4 fade-in duration-300 md:bottom-6 md:left-auto md:right-6 md:max-w-md">
          <div className="bg-card border border-border rounded-t-lg p-5 shadow-lg md:rounded-lg">
            <div className="flex items-start gap-3">
              <Cookie className="h-5 w-5 text-accent mt-0.5 shrink-0" />
              <div className="space-y-3">
                <p className="text-sm text-foreground">
                  We use cookies to analyze site traffic and improve your experience. By accepting, you consent to our use of analytics cookies.
                </p>
                <div className="flex gap-3">
                  <Button className="min-h-11 px-5" onClick={accept}>
                    Accept
                  </Button>
                  <Button className="min-h-11 px-5" variant="outline" onClick={decline}>
                    Decline
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;
